export enum ProductPermission {
    ANONYMOUS = 'ANONYMOUS',
    WEAK = 'WEAK-AUTH',
    STRONG = 'STRONG-AUTH',
}
